import PresencasResponse from 'models/PresencasResponse';
import { createContext } from 'react';

export interface IRelatorioPresentesAssessorContext {
  presencas: PresencasResponse | null;
  atualizarPresencas: Function;
  atualizandoPresencas: boolean;
}

export default createContext<IRelatorioPresentesAssessorContext>({
  presencas: null,
  atualizarPresencas: () => {},
  atualizandoPresencas: false,
});
